import type { FC, ReactNode } from 'react'

import { useId } from 'react'
import { cn } from '@/lib/utils'

interface LogoMarkProps {
    className?: string
}

interface LogoProps {
    tone?: 'light' | 'dark'
    className?: string
}

export const LogoMark: FC<LogoMarkProps> = ({ className }): ReactNode => {
    const gradientId = `webify-mark-${useId().replace(/[^a-zA-Z0-9_-]/g, '')}`

    return (
        <svg
            viewBox='0 0 40 40'
            fill='none'
            aria-hidden='true'
            className={cn('size-9 shrink-0', className)}
        >
            <defs>
                <linearGradient id={gradientId} x1='0' y1='0' x2='40' y2='40' gradientUnits='userSpaceOnUse'>
                    <stop offset='0' stopColor='#6A55F0' />
                    <stop offset='1' stopColor='#2E1F8F' />
                </linearGradient>
            </defs>

            <rect width='40' height='40' rx='11' fill={`url(#${gradientId})`} />
            <path d='M8.5 13 14.5 27.5 20.5 13' stroke='#5EEAD4' strokeWidth='3.6' strokeLinecap='round' strokeLinejoin='round' />
            <path d='M19.5 13 25.5 27.5 31.5 13' stroke='#FFFFFF' strokeWidth='3.6' strokeLinecap='round' strokeLinejoin='round' />
        </svg>
    )
}

export const Logo: FC<LogoProps> = ({ tone = 'dark', className }): ReactNode => {
    return (
        <span className={cn('inline-flex items-center gap-2.5', className)}>
            <LogoMark />

            <span className='flex flex-col leading-none'>
                <span className={cn('font-heading text-base font-bold tracking-tight', tone === 'light' ? 'text-white' : 'text-foreground')}>
                    Webify IT
                </span>

                <span className={cn('mt-1 font-mono text-[10px] font-medium uppercase tracking-[0.22em]', tone === 'light' ? 'text-white/55' : 'text-muted-foreground')}>
                    Technologies
                </span>
            </span>
        </span>
    )
}
